import { auth } from '../../firebase';

class ReportsService {
  constructor() {
    this.functionsUrl = process.env.REACT_APP_FUNCTIONS_URL || 'https://us-central1-your-project.cloudfunctions.net';
  }

  async generatePDF(reportType, reportData, companyId, dateRange, language = 'ar') {
    try {
      const user = auth.currentUser;
      if (!user) {
        throw new Error('User not authenticated');
      }

      const idToken = await user.getIdToken();
      
      const requestData = {
        reportType,
        reportData,
        companyId,
        dateRange,
        language
      };

      console.log('Sending PDF generation request:', {
        reportType,
        companyId,
        dateRange,
        functionsUrl: this.functionsUrl
      });

      const response = await fetch(`${this.functionsUrl}/generateReportPDF`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        },
        body: JSON.stringify(requestData)
      });

      console.log('PDF generation response status:', response.status);

      if (!response.ok) {
        const errorText = await response.text();
        console.error('PDF generation error response:', errorText);
        
        let errorData;
        try {
          errorData = JSON.parse(errorText);
        } catch (e) {
          errorData = { error: errorText || 'Failed to generate PDF' };
        }
        
        throw new Error(errorData.error || `HTTP ${response.status}: Failed to generate PDF`);
      }

      return response.blob();
    } catch (error) {
      console.error('Error generating PDF report:', error);
      throw error;
    }
  }

  downloadBlob(blob, filename) {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
}

export const reportsService = new ReportsService();